// types
import { FieldType, IField } from 'types/graphql'
// hooks
import { useCurrentTable } from 'hooks/risks/useCurrentTable'

export const useFieldType = (field: IField): Record<string, boolean> => {
  const { fieldLinks = [] } = useCurrentTable()
  const { fieldType, id } = field

  const typeMap: Record<string, boolean> = {
    isTag: fieldType === FieldType.Tag,
    isText: fieldType === FieldType.Text,
    isDate: fieldType === FieldType.Date,
    isTable: fieldType === FieldType.Table,
    isLabel: fieldType === FieldType.Label,
    isNumber: fieldType === FieldType.Number,
    isSwitch: fieldType === FieldType.Switch,
    isMatrix: fieldType === FieldType.RiskMatrix,
    isLookup: fieldType === FieldType.Lookup,
    isSection: fieldType === FieldType.Section,
    isPickList: fieldType === FieldType.PickList,
    isDocOrLink: fieldType === FieldType.DocumentOrLink,
    isRecordLinks: fieldType === FieldType.RecordLinks,
    isParentFields: fieldType === FieldType.ParentRelatedForms
  }

  const isFieldLink = fieldLinks.some(({ field }) => field.id === id)
  const isGenericField = !typeMap.isDocOrLink && !typeMap.isMatrix && !typeMap.isText

  return {
    ...typeMap,
    isFieldLink,
    isGenericField
  }
}
